import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder,FormGroup, FormControl,Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

declare var $:any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styles: ['./login.component.css'],
  encapsulation:ViewEncapsulation.None,
})
export class LoginComponent implements OnInit {

  loginFormGroup:FormGroup;
  username_error:string='';
  password_error:string='';
  group:Object={};
  showMe:boolean =false;
  loader_image:boolean=false
  emailPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$";

  constructor(private toastr: ToastrService,private route: ActivatedRoute,private _authService: AuthService,private formBuilder: FormBuilder) { 

    
    this.route.queryParams.subscribe(params => {

    

      if(Object.keys(params).length  > 0){
        console.log("params=======",params);
        
       let xparams = JSON.parse(atob(params.token))

       console.log("xparams=======",xparams);

       this._authService.login(xparams);

        
      } else{

       this.showMe =true;
      }




    });

  }

   
  checkInput(){
        
    if(this.loginFormGroup.controls['txt_username_login'].status=="INVALID"){

      this.toastr.error('Please enter valid email address', '', {timeOut: 2000});

    }else if(this.loginFormGroup.controls['txt_password_login'].status=="INVALID"){

      this.toastr.error('Please enter valid  password', '', {timeOut: 2000});
       
    }

  }

  ngOnInit() {

    this.group['txt_username_login']=new FormControl('',[Validators.required,Validators.pattern(this.emailPattern)]);
		this.group['txt_password_login']=new FormControl('',[Validators.required]);
		
		this.loginFormGroup =  this.formBuilder.group(this.group);
	
    
  }

  


  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    

    $('.message a').click(function(e){
      e.preventDefault();
      
      $('form').animate({height: "toggle", opacity: "toggle"}, "slow");
   });

   $(document).ready(function(){ 
    $('input').blur(function(event) {
    var inputValue = this.value;
    if (inputValue) {
      this.classList.add('value-exists');
    } else {
      this.classList.remove('value-exists');
    }
    });
    });

    $('.button-psswd').on('click', function() {
        
      if ($('.input-psswd').attr('psswd-shown') == 'false') {
          
          $('.input-psswd').removeAttr('type');
          $('.input-psswd').attr('type', 'text');
          
          $('.input-psswd').removeAttr('psswd-shown');
          $('.input-psswd').attr('psswd-shown', 'true');
          
          $('#open_eye').hide();
          $('#close_eye').show();
          
      }else {
          
          $('.input-psswd').removeAttr('type');
          $('.input-psswd').attr('type', 'password');
          
          $('.input-psswd').removeAttr('psswd-shown');
          $('.input-psswd').attr('psswd-shown', 'false');
          
            $('#open_eye').show();
          $('#close_eye').hide();
          
      }
      
  });	

  }

  login() {

  
    if(this.loginFormGroup.status =='VALID'){

      
      let data={
        username:this.loginFormGroup.value['txt_username_login'],
        password:this.loginFormGroup.value['txt_password_login']
      }
      this.loader_image=true
      this._authService.login(data)
      setTimeout(() => {
        this.loader_image=false
      }, 1000);
      
       
    }else{

      this.checkInput();
    }
    
  }

  loginAdmin() {
    this._authService.loginAdmin();
  }

}
